export const STEP_STATUS_MAPPING = {
    NONE: "none",
    OPEN: "open",
    IN_PRODUCTION: "inproduction",
    COMPLETED: "completed"
}